<template>
  <v-card
    max-width="400"
    min-height="300"
    max-height="330"
    class="mx-auto text-center my-8 pa-8"
    style="border-radius: 20px"
    elevation="1"
  >
    <v-card-text class="font">
      <slot name="Ar"></slot>
    </v-card-text>
    <v-card-text
      class="overflow-hidden font"
      style="font-size: 13px; font-weight: 400; margin-top: -20px"
    >
      <slot name="En"></slot>
    </v-card-text>

    <v-card-actions>
      <img
        src="../assets/logo.png"
        class="d-block mx-auto"
        width="50"
        alt="logo"
    /></v-card-actions>
  </v-card>
</template>
